// Look at: https://github.com/jbetancur/react-data-table-component/blob/master/src/DataTable/styles.js
    // This refers to all the style properties for a data table components
import DataTable, { createTheme } from 'react-data-table-component';

export const fuseDataTableTheme = createTheme('fuseDataTableTheme', {
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  background: {
    default: '#FFFFFF',
  },
  context: {
    background: '#e3f2fd',
    text: 'rgba(0, 0, 0, 0.87)',
  },
  divider: {
    default: 'rgba(0,0,0,.12)',
  },
  button: {
    default: 'rgba(0,0,0,.54)',
    focus: 'rgba(0,0,0,.12)',
    hover: 'rgba(0,0,0,.12)',
    disabled: 'rgba(0, 0, 0, .18)',
  },
  sortFocus: {
    default: 'rgba(0, 0, 0, .54)',
  },
  selected: {
    default: '#e3f2fd',
    text: 'rgba(0, 0, 0, 0.87)',
  },
  highlightOnHover: {
    default: '#EEEEEE',
    text: 'rgba(0, 0, 0, 0.87)',
  },
  striped: {
    default: '#FAFAFA',
    text: 'rgba(0, 0, 0, 0.87)',
  }
});

export const fuseDataTableCustomStyles = {
  table: {
    style: {
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
      margin: "5px 0px",
      minHeight: "35px",
      height: "auto"
    },
  },
  tableWrapper: {
    style: {
      display: 'table',
    },
  },
  header: {
    style: {
      fontSize: '22px',
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
      minHeight: '56px',
      paddingLeft: '16px',
      paddingRight: '8px',
    },
  },
  subHeader: {
    style: {
      backgroundColor: fuseDataTableTheme.background.default,
      minHeight: '52px',
    },
  },
  head: {
    style: {},
  },
  headRow: {
    style: {
      backgroundColor: fuseDataTableTheme.background.default,
      minHeight: '35px',
      borderBottomWidth: '1px',
      borderBottomColor: fuseDataTableTheme.divider.default,
      borderBottomStyle: 'solid',
    },
    denseStyle: {
      minHeight: '20px',
      height: "auto"
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: "bold",
      color: fuseDataTableTheme.text.primary,
      // paddingLeft: '16px',
      // paddingRight: '16px',
      padding: "3px 10px"
    },
    activeSortStyle: {
      color: fuseDataTableTheme.text.primary,
      '&:focus': {
        outline: 'none',
      },
      '&:hover:not(:focus)': {
        color: fuseDataTableTheme.sortFocus.default,
      },
    },
    inactiveSortStyle: {
      '&:focus': {
        outline: 'none',
        color: fuseDataTableTheme.sortFocus.default,
      },
      '&:hover': {
        color: fuseDataTableTheme.sortFocus.default,
      },
    },
  },
  contextMenu: {
    style: {
      backgroundColor: fuseDataTableTheme.context.background,
      fontSize: '18px',
      fontWeight: 400,
      color: fuseDataTableTheme.context.text,
      paddingLeft: '16px',
      paddingRight: '8px',
      transform: 'translate3d(0, -100%, 0)',
      transitionDuration: '125ms',
      transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
      willChange: 'transform',
    },
    activeStyle: {
      transform: 'translate3d(0, 0, 0)',
    },
  },
  cells: {
    style: {
      wordBreak: 'break-word',
      padding: "3px 10px",
    },
  },
  rows: {
    style: {
      minHeight: "auto",
      fontSize: '13px',
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
      maxHeight: "auto",
      '&:not(:last-of-type)': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: fuseDataTableTheme.divider.default,
      },
    },
    denseStyle: {
      height: "auto",
      padding: "0px"
    },
    selectedHighlightStyle: {
      // use nth-of-type(n) to override other nth selectors
      '&:nth-of-type(n)': {
        color: fuseDataTableTheme.selected.text,
        backgroundColor: fuseDataTableTheme.selected.default,
        borderBottomColor: fuseDataTableTheme.background.default,
      },
    },
    highlightOnHoverStyle: {
      color: fuseDataTableTheme.highlightOnHover.text,
      backgroundColor: fuseDataTableTheme.highlightOnHover.default,
      transitionDuration: '0.15s',
      transitionProperty: 'background-color',
      borderBottomColor: fuseDataTableTheme.background.default,
      outlineStyle: 'solid',
      outlineWidth: '1px',
      outlineColor: fuseDataTableTheme.background.default,
    },
    stripedStyle: {
      color: fuseDataTableTheme.striped.text,
      backgroundColor: fuseDataTableTheme.striped.default,
    },
  },
  expanderRow: {
    style: {
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
    },
  },
  expanderCell: {
    style: {
      flex: '0 0 48px',
    },
  },
  expanderButton: {
    style: {
      color: fuseDataTableTheme.button.default,
      fill: fuseDataTableTheme.button.default,
      backgroundColor: 'transparent',
      borderRadius: '2px',
      transition: '0.25s',
      height: '100%',
      width: '100%',
      '&:hover:enabled': {
        cursor: 'pointer',
      },
      '&:disabled': {
        color: fuseDataTableTheme.button.disabled,
      },
      '&:hover:not(:disabled)': {
        cursor: 'pointer',
        backgroundColor: fuseDataTableTheme.button.hover,
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: fuseDataTableTheme.button.focus,
      },
      svg: {
        margin: 'auto',
      },
    },
  },
  pagination: {
    style: {
      color: fuseDataTableTheme.text.secondary,
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: fuseDataTableTheme.background.default,
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: fuseDataTableTheme.divider.default,
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: 'px',
      cursor: 'pointer',
      transition: '0.4s',
      color: fuseDataTableTheme.button.default,
      fill: fuseDataTableTheme.button.default,
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: fuseDataTableTheme.button.disabled,
        fill: fuseDataTableTheme.button.disabled,
      },
      '&:hover:not(:disabled)': {
        backgroundColor: fuseDataTableTheme.button.hover,
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: fuseDataTableTheme.button.focus,
      },
    },
  },
  noData: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
    },
  },
  progress: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: fuseDataTableTheme.text.primary,
      backgroundColor: fuseDataTableTheme.background.default,
    },
  },
};